import { defineComponent as _defineComponent } from 'vue'
import {
  ref,
  unref,
  watch
} from 'vue';

import {
  CardStates
} from "@/Enums";

import {
  useI18n
} from "@/composables/useI18n";

import {
  debounce,
  isEmpty
} from "@/scripts/Common/HelperFunctions";

import {
  isWholeNumber
} from "@/scripts/Common/validators/defaultValidator";


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchFilter',
  emits: [
  'onSearchFilter',
],
  setup(__props, { emit: emits }) {

const {
  t,
} = useI18n();



const selectedState = ref<CardStates | undefined>();
const cardNumber = ref<string | undefined>();
const stateItems = [
  { text: t('card_state_assigned'), state: CardStates.Assigned },
  { text: t('card_state_unassigned'), state: CardStates.Unassigned },
  { text: t('card_state_unknown'), state: CardStates.Unknown },
];

const onHandleChange = () => {
  emits('onSearchFilter', {
    cardState: unref(selectedState),
    cardNumber: unref(cardNumber),
  });
};

const onHandleClearCardState = () => {
  selectedState.value = undefined;

  onHandleChange();
};
const onHandleClearCardNumber = () => {
  cardNumber.value = undefined;

  onHandleChange();
};

watch(() => cardNumber.value, debounce(() => {
  if(isEmpty(cardNumber.value)) cardNumber.value = undefined;

  if (cardNumber.value === undefined || isWholeNumber(cardNumber.value)) {
    onHandleChange()
  }
}));

watch(selectedState, () => {
  onHandleChange()
});


return { __sfc: true,t, emits, selectedState, cardNumber, stateItems, onHandleChange, onHandleClearCardState, onHandleClearCardNumber }
}

})